import type { ISlotsConfig, IContentRollConfig, ISlotPageConfig, } from './slots.types';
import { PAGE_TYPES } from 'Src/constants';
/**
 * globalSlots - слоты, которые могут использоваться на любой странице. Для получения этих слотов не нужен параметр page_type
 * articleSlots, indexPageSlots и т.д - слоты, которые используются только на конкретной странице.
 * Для получения этих слотов используется параметр page_type, отдаваемый с бэка.
 */
// Общие слоты для всех страниц
export const globalSlots: ISlotsConfig = {
    mobile: {
        // Портальная шапка
        promoButton1: '1585165',
        promoButton2: '1585167',
        scroll2site: '732610',
        // приложения в меню
        menuPortalApps: '6361',
        //@TODO Fullscreen
        fullscreen: '1',
        // Плашка Закон о рекомендательных технологиях
        recommendationSplash: '1420179',
        // NPS-опрос
        npsPoll: {
            id: '1265267',
            params: {
                version: 'touch',
            },
        },
        // Перетяжка над реколентой 360x300
        registrationBanner: '1727704',
        // Баннер в блоке консультаций 300x300
        consultationBanner: '1727706',
        // видео на главной
        videoWidget: {
            id: '1730793',
            params: {
                version: 'touch',
            },
        },
        // Слот с рекомендуемыми статьями на странице рубрик
        rubricSuggest: '6551',
        brandingFooter: '1734143',
        // Слот с реакциями в футере статьи
        articleFooterReactions: '1677287',
    },
    desktop: {
        // видео на главной
        videoWidget: {
            id: '1730793',
            params: {
                version: 'web',
            },
        },
        // Портальная шапка
        promoButton1: '1585162',
        promoButton2: '1585163',
        // NPS-опрос
        npsPoll: {
            id: '1265267',
            params: {
                version: 'web',
            },
        },
        // Плашка Закон о рекомендательных технологиях
        recommendationSplash: '1420179',
        // Перетяжка над реколентой 100%х250
        registrationBanner: '1727701',
        scroll2site: '732610',
        // Портальное меню
        portalHeadingSlot: {
            id: '3355',
            params: {
                ActiveEmail: '$Email',
                G_MailEvents: 'MailNewCnt',
                G_MyEvents: '$MyCnt',
                PH_Version: '2',
                LANG: 'ru_RU',
                PHE_devAuth: '1',
            },
        },
        // Сайдбар в блоке консультаций
        consultationBanner: '1727705',
        /* TODO */
        fourthArticleSwap: '1',
        aside300x600: '1732162',
        // Слот с реакциями в футере статьи
        articleFooterReactions: '1677287',
        // myWidget
        myWidget: '180576',
        brandingFooter: '1732163',
    },
};
// Статья
export const articleSlots: ISlotsConfig = {
    mobile: {
        headerSlot: '205716',
        brandingTopSSI: {
            id: '1734141',
            params: {
                with_branding: '1',
            },
        },
    },
    desktop: {
        headerSlot: '205716',
        //Перетяжка под шапкой 100%х250 ssi слот
        brandingTopSSI: {
            id: '1732154',
            params: {
                with_branding: '1',
            },
        },
    },
};
// Главная страница
export const indexPageSlots: ISlotsConfig = {
    mobile: {
        // Перетяжка над реколентой 360x300
        registrationBanner: '1727704',
    },
    desktop: {
        fourthArticleSwap: '1',
        // Перетяжка над реколентой 100%х250
        registrationBanner: '1727701',
    },
};
export const slots: ISlotPageConfig = {
    global: globalSlots,
    [PAGE_TYPES.article]: articleSlots,
    [PAGE_TYPES.index]: indexPageSlots,
    [PAGE_TYPES.kindDetail]: indexPageSlots,
    [PAGE_TYPES.kindRating]: indexPageSlots,
    [PAGE_TYPES.kindAlphabet]: articleSlots,
    [PAGE_TYPES.kindCompilation]: articleSlots,
    [PAGE_TYPES.rubric]: articleSlots,
    [PAGE_TYPES.consultationRubric]: articleSlots,
    [PAGE_TYPES.consultantListing]: articleSlots,
    [PAGE_TYPES.consultationConsultant]: indexPageSlots,
    [PAGE_TYPES.search]: articleSlots,
    [PAGE_TYPES.tag]: articleSlots,
    [PAGE_TYPES.user]: articleSlots,
    [PAGE_TYPES.consultantAsk]: articleSlots,
    [PAGE_TYPES.market]: articleSlots,
    [PAGE_TYPES.marketCategory]: articleSlots,
    [PAGE_TYPES.marketProduct]: articleSlots,
    [PAGE_TYPES.marketSearch]: articleSlots,
    [PAGE_TYPES.userContent]: articleSlots,
};
export const contentRollConfig: IContentRollConfig = {
    desktop: {
        regular: ['1732156'],
    },
    mobile: {
        regular: ['1732157'],
    },
};
